import React, { Component } from 'react';
import cn from 'classname';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import orderBy from 'lodash/orderBy';
import reduce from 'lodash/reduce';
import isNil from 'lodash/isNil';
import sumBy from 'lodash/sumBy';

import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import Calendar from '../shared/calendar/main';
import Filters from '../shared/filters/main';

import { formatMoney } from '../../../../shared/js/format';

import { selectors, actions } from './';

import './index.less';

class Table extends Component {
	constructor(props) {
		super(props);

		this.state = {
			level2: [],
			level3: [],
			sorting: {}
		};

		this.toggleLevel = this.toggleLevel.bind(this);
	}

	toggleLevel(n, id) {
		const level = `level${n}`;

		this.setState((state) => ({
			...state,
			[level]: state[level].includes(id)
				? state[level].filter((i) => i !== id)
				: state[level].concat(id)
		}));
	}

	sort(key, index) {
		this.setState((state) => {
			const isSameColumn = state.sorting.key === key && state.sorting.index === index;

			return {
				...state,
				sorting: isSameColumn && state.sorting.direction === 'asc' ? {} : {
					key,
					index,
					direction: isSameColumn ? !state.sorting.direction ? 'desc' : 'asc' : 'desc'
				}
			};
		});
	}

	renderInfo(type, { amount, length, approved, generic, count, profit }, i) {
		const sorting = this.state.sorting;
		const isHead = type === 'head';

		function getSortingDirection(key) {
			return sorting.key === key && sorting.index === i && sorting.direction;
		}

		return [
			<td
				className={cn(isHead && ['m-a-activity-sorting', getSortingDirection('amount')])}
				onClick={() => isHead && this.sort('amount', i)}
				title={type !== 'leaf' ? 'Кол-во "валидных" вебов (всего вебов)' : '"Валидный" веб?'}
				key={`amount-${i}`}
			>
				{type !== 'leaf' ? `${amount} (${length})` : (amount > 0 ? '✅' : '❌')}
			</td>,
			<td
				className={cn(isHead && ['m-a-activity-sorting', getSortingDirection('count')])}
				onClick={() => isHead && this.sort('count', i)}
				title='Кол-во всего лидов'
				key={`count-${i}`}
			>
				{count}
			</td>,
			<td
				className={cn(isHead && ['m-a-activity-sorting', getSortingDirection('approved')])}
				onClick={() => isHead && this.sort('approved', i)}
				title={`Кол-во апрувов (generic: ${generic})`}
				key={`approved-${i}`}
			>
				{approved}
			</td>,
			<td
				className={cn(isHead && ['m-a-activity-sorting', getSortingDirection('profit')], 'm-a-activity-profit')}
				onClick={() => isHead && this.sort('profit', i)}
				title='Профит'
				key={`profit-${i}`}
			>
				{!isNil(profit) ? `${formatMoney(profit)} $` : '?'}
			</td>,
			<td
				className={cn('m-a-activity-profit')}
				title='Per App (generic)'
				key={`perapp-${i}`}
			>
				{!isNil(profit) ? `${formatMoney(profit / generic, true, 1)} $` : '?'}
			</td>
		];
	}

	renderNode(row, id, level, isOpened) {
		return (
			<tr className={`level${level}`} key={id}>
				<td className='sticky'>
					<button
						onClick={() => this.toggleLevel(level + 1, id)}
					>
						<span>{isOpened ? '—' : '+'}</span>{row.name}
					</button>
				</td>

				{this.renderInfo('node', row.total)}

				{row.months.map(this.renderInfo.bind(this, 'node'))}
			</tr>
		);
	}

	renderLeaf(row, id, level) {
		return (
			<tr className={`level${level}`} key={id}>
				<td className='sticky'>
					<div>{row.name}</div>
				</td>

				{this.renderInfo('leaf', row.total)}

				{row.months.map(this.renderInfo.bind(this, 'leaf'))}
			</tr>
		);
	}

	renderRows() {
		const { sorting, level2, level3 } = this.state;

		const sortingPath = `${!isNil(sorting.index) ? `months[${sorting.index}]` : 'total'}.${sorting.key}`;

		return this.props.data.rows.reduce((rows, row) => {
			const adminRowId = row.id;
			const isOpened = level2.includes(adminRowId);

			rows.push(this.renderNode(row, adminRowId, 1, isOpened));

			if (isOpened) {
				rows.push(...row.rows.reduce((rows, row) => {
					const rankRowId = adminRowId + ':' + row.id;
					const isOpened = level3.includes(rankRowId);

					rows.push(this.renderNode(row, rankRowId, 2, isOpened));

					if (isOpened) {
						const affiliates = !sorting.key ? row.rows : orderBy(row.rows, sortingPath, sorting.direction);

						rows.push(...affiliates.reduce((rows, row) => {
							const affiliateRowId = rankRowId + row.id;

							rows.push(this.renderLeaf(row, affiliateRowId, 3));

							return rows;
						}, []));
					}

					return rows;
				}, []));
			}

			return rows;
		}, []);
	}

	render() {
		const { intl, filters, calendar, data, ...props } = this.props;

		const months = reduce(data.rows.map((row) => row.months), (array, months) => array.map((a, i) => ({
			amount: a.amount + months[i].amount,
			length: a.length + months[i].length,
			approved: a.approved + months[i].approved,
			generic: a.generic + months[i].generic,
			count: a.count + months[i].count,
			profit: (a.profit || months[i].profit) && (a.profit + months[i].profit)
		})));

		return (
			<div className='m-a-activity'>
				<div className='m-a-activity-actions'>
					<div className='m-a-activity-filters clearfix'>
						<Filters
							intl={intl} {...filters} filters={filters} // for crutch support
						/>
					</div>
					<Calendar
						intl={intl}
						{...calendar}
						onInit={calendar.calendarInit}
						onToggle={calendar.calendarToggle}
						onChange={calendar.calendarChange}
						onApply={calendar.calendarApply}
					/>
					<button
						className='ui-btn ui-btn-primary'
						onClick={props.apply}
					>
						{intl('Apply')}
					</button>
					<button
						className='ui-btn ui-btn-secondary ui-icon-clear'
						onClick={props.clear}
					/>
				</div>

				<div className='m-a-activity-table-wrapper'>
					<table>
						<thead>
							<tr>
								<th className='sticky' />

								<th colSpan={5}>
									{intl('Total')}
								</th>

								{data.months.map((month) => (
									<th colSpan={5} key={month}>
										{month.format('MMM YY')}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{months && (
								<tr>
									<td className='sticky' />

									{this.renderInfo('head', {
										amount: sumBy(data.rows, 'total.amount'),
										length: sumBy(data.rows, 'total.length'),
										approved: sumBy(data.rows, 'total.approved'),
										generic: sumBy(data.rows, 'total.generic'),
										count: sumBy(data.rows, 'total.count'),
										profit: sumBy(data.rows, 'total.profit')
									})}

									{months.map(this.renderInfo.bind(this, 'head'))}
								</tr>
							)}
							{this.renderRows()}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(
	withPageContainer(withIntl(Table), { name: 'Activity' })
);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/managers-affiliates-activity/main.js